<script>
import {
  resolveActionName,
  resolveTeamIds,
  resolveLabels,
  resolveAgents,
} from 'dashboard/helper/actionLabelResolvers';
import { mapGetters } from 'vuex';

export default {
  props: {
    flow: {
      type: Object,
      required: true,
    },
  },
  computed: {
    resolvedFlow() {
      return this.flow.actions.map(action => {
        return {
          // display_name pré-resolvido (fluxos: blocos fora do vocabulário de
          // fluxo quebrariam o resolveActionName, que não tem guarda).
          actionName:
            action.display_name || resolveActionName(action.action_name),
          actionValue: this.getActionValue(
            action.action_name,
            action.action_params
          ),
        };
      });
    },
    ...mapGetters({
      labels: 'labels/getLabels',
      teams: 'teams/getTeams',
      agents: 'agents/getAgents',
    }),
  },
  methods: {
    getActionValue(key, params) {
      const actionsMap = {
        assign_team: resolveTeamIds(this.teams, params),
        assign_team_to_contact: resolveTeamIds(this.teams, params),
        add_conversation_label: resolveLabels(this.labels, params),
        remove_conversation_label: resolveLabels(this.labels, params),
        add_contact_label: resolveLabels(this.labels, params),
        remove_contact_label: resolveLabels(this.labels, params),
        assign_agent: resolveAgents(this.agents, params),
        assign_agent_to_contact: resolveAgents(this.agents, params),
        mute_conversation: null,
        snooze_conversation: null,
        resolve_conversation: null,
        remove_assigned_team: null,
        remove_assigned_agent: null,
        remove_contact_assigned_team: null,
        remove_contact_assigned_agent: null,
        send_webhook_event: params[0],
        send_message: params[0],
        send_email_transcript: params[0],
        add_private_note: params[0],
      };
      return actionsMap[key] || '';
    },
  },
};
</script>

<template>
  <!-- Sem posicionamento próprio: quem posiciona é o PopoverPortal, que tira o
       elemento da árvore do sidebar (três ancestrais com overflow o cortavam). -->
  <div
    class="flow-preview max-h-[22.5rem] w-64 rounded-md bg-surface-raised overflow-y-auto p-4 text-left rtl:text-right"
  >
    <h6 class="text-sm text-body mb-4">
      {{ flow.name }}
    </h6>
    <div
      v-for="(action, i) in resolvedFlow"
      :key="i"
      class="relative pl-4 flow-block"
    >
      <div
        v-if="i !== flow.actions.length - 1"
        class="top-[0.390625rem] absolute -bottom-1 left-0 w-px bg-surface-hover"
      />
      <div
        class="absolute -left-[0.21875rem] top-[0.2734375rem] w-2 h-2 rounded-full bg-white dark:bg-slate-200 border-2 border-solid border-line-faint"
      />
      <p class="text-xs text-subtle mb-1">
        {{ action.actionName }}
      </p>
      <p class="text-body">{{ action.actionValue }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.flow-preview {
  /* Antes o preview era recortado pelo card e lia como parte dele. Agora
     flutua sobre a app inteira (PopoverPortal), e sem contorno próprio ficaria
     colado no conteúdo de trás — mesma moldura do .flow-popover. */
  box-shadow: 0 8px 24px rgb(0 0 0 / 0.18);
  border: 1px solid rgb(var(--fd-line, 215 219 223));

  .flow-block {
    &:not(:last-child) {
      @apply pb-2;
    }
  }
}
</style>
